import React from 'react';
import { DateInput as MantineDateInput, DateInputProps } from '@mantine/dates';
import dayjs from 'dayjs';
import { IconCalendar } from '@tabler/icons-react';

const DATE_FORMATS = [
  // ISO format
  'YYYY-MM-DD',
  // Common UK date formats
  'DD/MM/YYYY',
  'DD-MM-YYYY',
  'DD.MM.YYYY',
  // Compact UK date formats
  'DDMMYYYY',
  // Two-digit year formats
  'DD/MM/YY',
  'DD-MM-YY',
  'DD.MM.YY',
  'DDMMYY',
];

function parseUKDate(input: string): Date | null {
  if (!input?.trim()) return null;
  const trimmed = input.trim();

  for (const format of DATE_FORMATS) {
    const parsed = dayjs(trimmed, format, true);
    if (parsed.isValid()) {
      return parsed.toDate();
    }
  }

  return null;
}

export function DateInput(props: DateInputProps) {
  return (
    <MantineDateInput
      clearable
      placeholder="dd / mm / yyy"
      valueFormat="D MMMM YYYY"
      dateParser={parseUKDate}
      allowDeselect={false}
      leftSection={<IconCalendar />}
      {...props}
    />
  );
}
